import {CustomerContactPerson} from './CustomerContactPerson';
import {CustomerAddress} from './CustomerAddress';
import {ProductType} from './ProductType';
import {ProductContent} from './ProductContent';
import {ProductCategory} from './ProductCategory';
import {BaseObject} from './BaseObject';

export class ContractEvent extends BaseObject {
    id: number;
    name: string;
    note: string;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ContractEvent.ts